import CLICKUP from "@/c_clickup";

export default {
  //----- GENERAL -----------------------------------------------------------------------

  PRODUCTION: false,

  API: "/api/",
  // API: "http://inventory.duke.local/",

  API_FUNCTIONS: "functions-inventory.php",
  // ASSETS: "",
  ASSETS: "/public",

  //----- USER TYPES -----------------------------------------------------------------------
  USER_TYPE_INDEX: ["Admin", "Super User", "Manufacturer", "Polisher", "Watchmaker", "Administration"],
  USER_TYPE: {
    ADMIN: 0,
    SUPER_USER: 1,
    MANUFACTURER: 2,
    POLISHER: 3,
    WATCHMAKER: 4,
    ADMINISTRATION: 5,
  },

  // user object
  USER: {
    username: "",
    email: "",
    user_type: 0,
    password: "",
    password_2: "",
  },

  //----- INVENTORY TYPES -----------------------------------------------------------------------

  INVENTORY_TYPE_INDEX: ["Raw", "Material", "Component", "Polished", "Pre-assembled", "Assembled", "Watch"],
  INVENTORY_TYPE: {
    RAW: 0,
    MATERIAL: 1,
    COMPONENT: 2,
    POLISHED: 3,
    PRE_ASSEMBLED: 4,
    ASSEMBLED: 5,
    WATCH: 6,
  },
  INVENTORY_TYPE_ICON: ["rectangle-portrait", "coins", "cog", "sparkles", "cogs", "clock", "watch"],
  CATEGORY_INDEX: ["Movement", "Dial", "Case", "Strap", "Buckle", "Other"],
  CATEGORY: {
    MOVEMENT: 0,
    DIAL: 1,
    CASE: 2,
    STRAP: 3,
    BUCKLE: 4,
    OTHER: 5,
  },
  CATEGORY_ICON: ["cog", "clock", "octagonal", "watch", "watch", "watch"],

  //----- ORDER TYPES -----------------------------------------------------------------------

  ORDER_TYPE_INDEX: [
    "Raw-Manufacturing",
    "Manufacturing",
    "Finishing",
    "Pre-Assembling",
    "Assembling",
    "Watch Assembling",
    "External Finishing",
  ],
  ORDER_TYPE: {
    RAW_MANUFACTURING: 0,
    MANUFACTURING: 1,
    FINISHING: 2,
    PRE_ASSEMBLING: 3,
    ASSEMBLING: 4,
    WATCH_ASSEMBLING: 5,
    EXTERNAL_FINISHING: 6,
  },

  //----- ORDER STATUS -----------------------------------------------------------------------
  // order status
  ORDER_STATUS_INDEX: ["not started", "in progress", "quality control", "cancelled", "rejected", "on hold", "completed"],
  ORDER_STATUS: {
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    QUALITY_CONTROL: 2,
    CANCELLED: 3,
    REJECTED: 4,
    ON_HOLD: 5,
    COMPLETED: 6,
  },

  // order status color
  ORDER_STATUS_COLORS: ["badge-secondary", "badge-warning", "badge-info", "badge-danger", "badge-danger", "badge-danger", "badge-success"],

  //----- INVENTORY ITEM -----------------------------------------------------------------------

  // inventory item object
  INVENTORY_ITEM: {
    id: 0,
    ref: "",
    name: "",
    description: "",
    type: 0,
    category: 0,
    active: 0,
    material: 0,
    external: 0,
    external_finishing: 0,
    quantity: 0,
    qn_reserve: 0,
    quantity_in_use: 0,
    qn_min: 1,
    qn_min_order: 1,
    refill_limit: 0,
    price: 0,
    machine: 0,
    base: 0,
    prod_time: 0,
    img_path: "",
    link: "",
    // parent_ref: "",
  },

  //----- MATERIALS -----------------------------------------------------------------------

  MATERIAL_INDEX: [
    "TG5",
    "CFT",
    "CFAUR",
    "CFAUY",
    "AUW",
    "AUY",
    "AUR",
    "SA",
    "SN",
    "SG",
    "SB",
    "SR",
    "SV",
    "RU",
    "W",
    "CU37",
    "CUNI",
    "NBR",
    "S316L",
    "SDUR",
    "BIOF",
    "OTHER",
    "MULTI",
  ],
  MATERIAL_INDEX_LABEL: [
    "Titane Grade 5",
    "Carbone/Titane",
    "Carbone/Or Rose",
    "Carbone/Or Jaune",
    "Or Blanc",
    "Or Jaune",
    "Or Rose",
    "Saphir",
    "Saphir Noir",
    "Saphir Gris",
    "Saphir Bleu",
    "Saphir Rouge",
    "Saphir Vert",
    "Rubis",
    "Tungstène",
    "Laiton",
    "Maillechort",
    "Caoutchoucs Nitrile",
    "Acier 316L",
    "Acier Durnico",
    "Bioflex",
    "Autre",
    "Plusieurs",
  ],
  MATERIAL: {
    TITANE: 0,
    CFT: 1,
    CFAUR: 2,
    CFAUY: 3,
    AUW: 4,
    AUY: 5,
    AUR: 6,
    SA: 7,
    SN: 8,
    SG: 8,
    SB: 8,
    SR: 8,
    SV: 8,
    RU: 9,
    W: 10,
    CU37: 11,
    CUNI: 12,
    NBR: 13,
    S316L: 14,
    SDUR: 15,
    BIOF: 16,
    OTHER: 17,
    MULTI: 18,
  },

  //----- MANUFACTURING ORDER -----------------------------------------------------------------------

  // order object
  MANUFACTURING_ORDER: {
    id: 0,
    serial_nb: "0",
    item_id: "Select an item",
    name: "",
    description: "",
    type: 1,
    status: 0,
    active: 0,
    quantity: 0,
    qn_result: 0,
    qn_waste: 0,
    img_path: "",
    link_name: "",
    date_due: null,
    assigned_to: "",
    created_by: "",
    completed_on: "",

    //from clickup
    priority: 0,

    // not in db
    consume: [],
  },

  // orders prefix
  ORDER_ID_PREFIX: ["RMO", "MO", "FO", "PAO", "AO", "WAO", "EFO"],

  //----- CONSUME -----------------------------------------------------------------------

  // consume object
  CONSUME: {
    id: 0,
    order_id: 0,
    item_id: 1,
    item_type: 0,
    item_qn: 1,
    item_og_qn: 1,
  },

  //----- PURCHASING ORDER -----------------------------------------------------------------------

  // po object
  PURCHASING_ORDER: {
    id: 0,
    tool: 0,
    type: 0,
    status: 0,
    item_id: "Select an item",
    item_name: "",
    quantity: 0,
    price: 0,
    priority: 3,
    eta: "",
    description: "",
    task_id: "",
    completed_on: "",
  },

  // po type
  PURCHASING_ORDER_TYPE_INDEX: ["Tool", "Material", "Component"],
  PURCHASING_ORDER_TYPE: {
    TOOL: 0,
    MATERIAL: 1,
    COMPONENT: 2,
  },
  // po status
  PURCHASING_ORDER_STATUS_INDEX: ["not started", "in progress", "order placed", "in delivery", "delivered", "on hold", "completed"],
  PURCHASING_ORDER_STATUS: {
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    ORDER_PLACED: 2,
    IN_DELIVERY: 3,
    DELIVERED: 4,
    ON_HOLD: 5,
    COMPLETED: 6,
  },

  // po status color
  PURCHASING_ORDER_STATUS_COLORS: [
    "badge-warning",
    "badge-info",
    "badge-info",
    "badge-info",
    "badge-info",
    "badge-danger",
    "badge-success",
  ],

  PRIORITY_STRINGS: ["Undefined", "Urgent", "High", "Normal", "Low"],

  //----- MOVEMENT CATALOG -----------------------------------------------------------------------

  // movement object
  MOVEMENT: {
    id: 0,
    ref: "",
    item_id: 0,
    name: "",
    description: "",
    components_nb: 0,
    active: 1,
    category: 0,
    material: 0,
    modified_on: new Date(),
  },

  // movement status
  MOVEMENT_TYPE_INDEX: ["tourbillon", "no tourbillon", "automatic", "manual"],
  MOVEMENT_TYPE: {
    TOURBILLON: 0,
    NO_TOURBILLON: 1,
    AUTOMATIC: 2,
    MANUAL: 3,
  },

  //----- TOOLS -----------------------------------------------------------------------

  // tool object
  TOOL: {
    id: 0,
    ref: "",
    ref_supplier: "",
    ref_supplier_2: "",
    machine_id: 0,
    name: "",
    description: "",
    quantity: 0,
    price: 0,
    active: 1,
    status: 1,
    refill_limit: 0,
    img_path: "",
    modified_on: new Date(),
  },

  //----- MACHINES CATALOG -----------------------------------------------------------------------
  MACHINES_INDEX: ["Haas", "Datron", "Willemin", "Hanwha", "Polishing", "Assembling", "Other"],
  MACHINES: {
    HAAS: 0,
    DATRON: 1,
    WILLEMIN: 2,
    HANWHA: 3,
    POLISHING: 4,
    ASSEMBLING: 5,
    OTHER: 5,
  },

  //----- COSTS ------------------------------------------------------------------
  //   HAAS	110	110
  // DATRON	70	70
  // CHIRON	310	310
  // TSUGAMI	170	680
  // FINISHING	100	0
  // ASSEMBLING	100	0

  COSTS: [
    {
      hourly: 110,
      fixed: 110,
    },
    {
      hourly: 70,
      fixed: 70,
    },
    {
      hourly: 310,
      fixed: 310,
    },
    {
      hourly: 170,
      fixed: 680,
    },
    {
      hourly: 100,
      fixed: 0,
    },
    {
      hourly: 110,
      fixed: 0,
    },
    {
      hourly: 0,
      fixed: 0,
    },
  ],

  //----- MATERIAL SUPPLIER CATALOG -----------------------------------------------------------------------
  MATERIAL_SUPPLIER_INDEX: ["ISOSWISS", "STETTLER"],
  MATERIAL_SUPPLIER: {
    ISOSWISS: 0,
    STETTLER: 1,
  },

  //----- TOOL SUPPLIER CATALOG -----------------------------------------------------------------------
  TOOL_SUPPLIER_INDEX: ["INNOVATOOLS", "DIXI", "MAGAFOR", "APPLITEC"],
  TOOL_SUPPLIER: {
    INNOVATOOLS: 0,
    DIXI: 1,
    MAGAFOR: 2,
    APPLITEC: 3,
  },

  //----- SUPPLIERS ------------------------------------------------------------------
  SUPPLIER: {
    id: 0,
    ref: "",
    name: "",
    country: "",
    type: "",
    specialties: [],
    activity: "",
    description: "",
    img_path: "",
    modified_on: new Date(),
  },

  //----- TABLES ------------------------------------------------------------------

  TABLES: {
    MOVEMENTS: "movements",
    DIALS: "dials",
    CASES: "cases",
  },

  //----- NOTIFICATIONS ------------------------------------------------------------------

  // notif type
  NOTIFICATION_TYPE_INDEX: [
    "order_created",
    "order_updated",
    "order_deleted",
    "order_status_changed",
    "order_status_changed_quality_control",
    "order_status_changed_rejected",
    "order_status_changed_cancelled",
    "order_completed",
    "order_uncompleted",
    "order_user_assigned",
    "inventory_item_added",
    "inventory_item_updated",
    "inventory_item_deleted",
    "inventory_item_quantity_changed",
    "components_list_changed",
    "purchasing_order_created",
    "purchasing_order_updated",
    "purchasing_order_deleted",
    "purchasing_order_status_changed",
    "purchasing_order_completed",
  ],
  NOTIFICATION_TYPE: {
    ORDER_CREATED: 0,
    ORDER_UPDATED: 1,
    ORDER_DELETED: 2,
    ORDER_STATUS_CHANGED: 3,
    ORDER_STATUS_CHANGED_QUALITY_CONTROL: 4,
    ORDER_STATUS_CHANGED_REJECTED: 5,
    ORDER_STATUS_CHANGED_CANCELLED: 6,
    ORDER_COMPLETED: 7,
    ORDER_UNCOMPLETED: 8,
    ORDER_USER_ASSIGNED: 9,
    INVENTORY_ITEM_ADDED: 10,
    INVENTORY_ITEM_UPDATED: 11,
    INVENTORY_ITEM_DELETED: 12,
    INVENTORY_ITEM_QUANTITY_CHANGED: 13,
    COMPONENTS_LIST_CHANGED: 14,
    PURCHASING_ORDER_CREATED: 15,
    PURCHASING_ORDER_UPDATED: 16,
    PURCHASING_ORDER_DELETED: 17,
    PURCHASING_ORDER_STATUS_CHANGED: 18,
    PURCHASING_ORDER_COMPLETED: 19,
  },

  // notif status
  NOTIFICATION_STATUS_INDEX: ["Unread", "Read"],
  NOTIFICATION_STATUS: {
    UNREAD: 0,
    READ: 1,
  },

  // notif object
  NOTIFICATION: {
    id: 0,
    type: 0,
    status: 0,
    createdBy: "",
  },

  //----- GETTERS ------------------------------------------------------------------

  // (CAPITALIZE)
  GET_TYPE_INDEX_FROM_STRING(item) {
    if (item != null && item != "") return this.INVENTORY_TYPE_INDEX.indexOf(this.capitalize(item.trim()));
    else return -1;
  },
  // (CAPITALIZE)
  GET_CATEGORY_INDEX_FROM_STRING(item) {
    if (item != null && item != "") return this.CATEGORY_INDEX.indexOf(this.capitalize(item.trim()));
    else return -1;
  },
  // (ALL CAPS)
  GET_MATERIAL_INDEX_FROM_STRING(item) {
    if (item != null && item != "") return this.MATERIAL_INDEX.indexOf(item.toUpperCase());
    else return -1;
  },
  // (CAPITALIZE)
  GET_MACHINE_INDEX_FROM_STRING(item) {
    if (item != null && item != "") return this.MACHINES_INDEX.indexOf(this.capitalize(item.trim()));
    else return -1;
  },
  capitalize(str) {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  },

  //----- UTILITIES ------------------------------------------------------------------

  getTrimmedId(completeId, lenght) {
    if (!completeId) return "";
    return completeId.substring(0, lenght);
  },
  getTrimmedId12(completeId) {
    if (!completeId) return "";
    return completeId.substring(0, 12);
  },
  isInt: function (value) {
    return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
  },
  roundUp(number) {
    return Math.round((number + Number.EPSILON) * 100) / 100;
  },
  formatPrice(value) {
    return new Intl.NumberFormat("de-DE", {
      // Use "de-DE" for correct EUR format
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
    }).format(value);
  },
  formatPriceCSV(value) {
    return new Intl.NumberFormat("de-DE", {
      // Use "de-DE" for correct EUR format
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
    }).format(value);
  },

  //----- CLICK UP ------------------------------------------------------------------
  CLICKUP,
};
